export {
  default,
  getStaticPaths,
  getStaticProps,
} from 'containers/Privacy/Privacy';
